export const environment = {
  production: true,
  endpoint: 'https://api.hunter-crm.com/huntercrm',
  api: 'https://api.hunter-crm.com',
  registration: 'https://api.hunter-crm.com/registrations',
  relation: 'https://api.hunter-crm.com/relations',
  nominatim: "https://nominatim.openstreetmap.org"
};
